import { Component, OnInit, Input } from '@angular/core';
import { StreApp } from 'src/app/models/streapp.model';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'overview-card',
  templateUrl: './overview-card.component.html',
  styleUrl: './overview-card.component.scss'
})
export class OverviewCardComponent {
  @Input() streapp: StreApp;
  thumbnail: string;

  constructor(private readonly authService: AuthService) {}

  ngOnInit(): void {
    this.setThumbnail();
  }

  isAdultOrLowImpact(): boolean {
    if (this.streapp.isHighImpactEvent) {
      if (this.authService.isAuthenticated()) {
        if (this.authService.isAdult) {
          return true;
        }
      }
      return false;
    }

    return true;
  }

  private setThumbnail(): void {
    if (this.validURL(this.streapp.thumbnail)) {
      this.thumbnail = this.streapp.thumbnail;
    } else {
      this.thumbnail = 'data:image/jpeg;base64,' + this.streapp.thumbnail;
    }
  }

  private validURL(str) {
    var pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i'
    ); // fragment locator
    return !!pattern.test(str);
  }
}
